import type { RequestConfig } from '@customTypes/index';
import type { DayScheduleItem } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetClubProfileScheduleRequest = {
  clubId: string;
};

export type GetClubProfileScheduleParams =
  RequestConfig<GetClubProfileScheduleRequest>;

export const getClubProfileSchedule = async ({
  params,
  config
}: GetClubProfileScheduleParams) =>
  api.get<DayScheduleItem[] | []>(
    `/api/ClubProfile/schedule/${params.clubId}`,
    config
  );
